import { useStateValue } from "../context/StateValueContext";
import { hasPermission } from "../functions/permissionUtils";
import { PERMISSIONS } from "../constants/permissions";

export type OrderInsightsAccess = "visible" | "hidden" | "loading" | "error";

// Clients default to hidden until settings resolve (orderInsightsEnabled === null),
// so Deflections / Order Insights never flash before we know the company is gated.
// "error" means the settings fetch failed and the answer is unknowable without a retry.
// Admins/agents with OI_ALL or ALERTS_ALL always see the Deflections group.
export function useOrderInsightsAccess(): OrderInsightsAccess {
  const [{ user, orderInsightsEnabled, companySettingsFailed }] = useStateValue();
  if (hasPermission(user, PERMISSIONS.OI_ALL) || hasPermission(user, PERMISSIONS.ALERTS_ALL)) {
    return "visible";
  }
  if (!hasPermission(user, PERMISSIONS.OI_OWN)) return "hidden";
  if (companySettingsFailed) return "error";
  if (orderInsightsEnabled === null) return "loading";
  return orderInsightsEnabled ? "visible" : "hidden";
}

export function useOrderInsightsVisible(): boolean {
  return useOrderInsightsAccess() === "visible";
}
